let KDBindTypeTagLookup: Record<string, string[]> = {
	Leather: ["beltRestraints", "leathersuffsSpell"],
	Latex: ["latexRestraints"],
	Rope: ["ropeRestraints"],
	Metal: ["chainRestraints", "shackleRestraints", "handcuffer"],
	MagicRope: ["ropeMagicStrong"],
	Slime: ["slimeRestraintsRandom"],
	Ice: ["iceRestraints"],
	Tape: ["vinylTape"],
	Vine: ["vineRestraints"],
	Energy: ["cyberLink"],
	Magic: ["ribbonRestraints", "ribbonRestraintsLight"],
}